var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeSpace3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1390,
    height: 50,
    viewBox: "0 0 1390 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1390L1350 50H40L0 0Z",
    fill: "#020842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSpace3);
export default __webpack_public_path__ + "static/media/shape_space_3.9bc891d6411fa165d4538ff4daf51393.svg";
export { ForwardRef as ReactComponent };